import React from "react";
import classNames from "classnames";

import { ConcreteNotification, NotificationType, Props } from "./types";
import { MentionInComment } from "./mentionInComment";
import { ReplyToComment } from "./replyToComment";
import { AddedToTask } from "./addedToTask";
import { AddedToProject } from "./addedToProject";
import { AddedToEvent } from "./addedToEvent";
import { DelayedTask } from "./delayedTask";
import { ExportBiFinished } from "./exportBiFinished";
import styles from "./styles.scss";

function Notification({ notification, close }: Props) {
  const n = notification as ConcreteNotification;

  return (
    <div className={styles.notification}>
      <div className={styles.readIndication}>
        <div
          className={classNames(styles.readMark, {
            [styles.read]: n.isRead,
          })}
        />
      </div>
      <div className={styles.main}>
        {n.type === NotificationType.MENTION_IN_COMMENT ? (
          <MentionInComment notification={n} close={close} />
        ) : n.type === NotificationType.REPLY_TO_COMMENT ? (
          <ReplyToComment notification={n} close={close} />
        ) : n.type === NotificationType.ADDED_TO_TASK ? (
          <AddedToTask notification={n} close={close} />
        ) : n.type === NotificationType.ADDED_TO_EVENT ? (
          <AddedToEvent notification={n} close={close} />
        ) : n.type === NotificationType.ADDED_TO_PROJECT ? (
          <AddedToProject notification={n} close={close} />
        ) : n.type === NotificationType.DELAYED_TASK ? (
          <DelayedTask notification={n} close={close} />
        ) : (
          n.type === NotificationType.EXPORT_BI_FINISHED && (
            <ExportBiFinished notification={n} close={close} />
          )
        )}
      </div>
    </div>
  );
}

export { Notification };
